import {
  FETCH_CNC_VOUCHER_SENT_REPORT,
  FETCH_CNC_VOUCHER_SENT_REPORT_SUCCESS,
  FETCH_CNC_VOUCHER_SENT_REPORT_FAILURE,
  RESET_CNC_VOUCHER_SENT_REPORT,
  RESEND_CNC_VOUCHER,
  RESEND_CNC_VOUCHER_SUCCESS,
  RESEND_CNC_VOUCHER_FAILURE,
} from "./cncVoucherTypes";

export const fetchCncVoucherSentReport = ({ orderNumber, emailId }) => ({
  type: FETCH_CNC_VOUCHER_SENT_REPORT,
  payload: { orderNumber, emailId },
});

export const fetchCncVoucherSentReportSuccess = ({ voucherSentReport }) => ({
  type: FETCH_CNC_VOUCHER_SENT_REPORT_SUCCESS,
  payload: voucherSentReport,
});

export const fetchCncVoucherSentReportFailure = ({ error }) => ({
  type: FETCH_CNC_VOUCHER_SENT_REPORT_FAILURE,
  error: error,
});

export const resetCncVoucherSentReport = () => ({
  type: RESET_CNC_VOUCHER_SENT_REPORT,
});

export const resendCncVoucher = ({ postBody }) => ({
  type: RESEND_CNC_VOUCHER,
  payload: { postBody },
});

export const resendCncVoucherSuccess = ({ response }) => ({
  type: RESEND_CNC_VOUCHER_SUCCESS,
  payload: response,
});

export const resendCncVoucherFailure = ({ error }) => ({
  type: RESEND_CNC_VOUCHER_FAILURE,
  payload: error,
});
